module.exports = __webpack_public_path__ + "static/img/antpay.7b79e4ed.png";